import { useContext, useEffect, useRef, useState } from "react";
import { showToast } from "../../../../helpers/ToastifyHelper";
import { Form, Formik } from "formik";
import { CircularProgress, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import SearchComponent from "../../../../components/OB/SearchComponent";
import IlanReklamVergisiTarifeleriPopup from "../../../../components/OB/popups/IlanReklamTarifeleriPopUp";
import TableComponent from "../../../../components/OB/TableComponent";
import SessionStorageService from "../../../../services/StorageService";
import { useNavigate } from "react-router";
import OdemeEmirleriAPI from "../../../../apis/OB/Get/OdemeEmirleriAPI";
import AciklamaAndUserControlPopup from "../../../../components/OB/popups/aciklama-usercontrol-popup";
const OdemeEmirleri: React.FC = () => {

    const columns = [
        { header: "Düzenlenme Tarihi", field: "duzenlenmeTarihi", className: "text-center" },
        { header: "Cilt/ Sayfa", field: "ciltSayfa", className: "text-center" },
        { header: "Tebliğ Tarihi", field: "tebligTarihi", className: "text-center" },
        { header: "Tebliğ Şekli Açıklaması", field: "tebligSekliAciklamasi", className: "text-center" },
        { header: "Kesinleşme Tarihi", field: "kesinlesmeTarihi", className: "text-center" },
        { header: "Son İhtar Tarihi", field: "sonIhtarTarihi", className: "text-center" },
        { header: "İade Tarihi", field: "iadeTarihi", className: "text-center" },
        { header: "İkinici İade Tarihi", field: "_2IadeTarihi", className: "text-center" },
        { header: "Tahakkuk Eden", field: "tahakkukEden", className: "text-center" },
        { header: "Ödenmeyen", field: "odenmeyen", className: "text-center" },

    ];
    const [data, setData] = useState<any[]>([]);
    const [tarifeGetData, setTarifeGetData] = useState<any[]>([]);
    const [searchControl, setSearchControl] = useState<boolean>(true);
    const [durum, setDurum] = useState(1);
    const [isLoading, setisLoading] = useState<boolean>(false);
    //Pop-Up
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const openPopup = () => {
        isPopupVisible == true ?
            setIsPopupVisible(false) :
            setIsPopupVisible(true);
    };
    //Kullanıcı Login control ve yönlendirme
    const navigate = useNavigate();
    let user = SessionStorageService.getUserInfo();
    const [userControlPopup, setUserControlPopup] = useState(false);
    const closeUserControlPopup = () => {
        setUserControlPopup(false);
        navigate(-1);
    }
    const [isLoad, setIsLoad] = useState(true);
    useEffect(() => {

        if (user == null) {

            setUserControlPopup(true);
        } else {
            setIsLoad(false);
        }

    }, []);
    //EvKatSayiDegerlemeOraniAPI
    useEffect(() => {
        fetchData(false);
    }, [])


    const fetchData = async (isPass: boolean = true) => {
        if (user != null) {
            setisLoading(true);
            const response = await OdemeEmirleriAPI.getOdemeEmirleriListe(

                user?.sicilKodu,
                durum

            );
            setData(response.data);
            setTimeout(() => {
                setisLoading(false);

            }, 100)
            setSearchControl(true)
            if (response.data.length < 1)
                showToast("Kayıt Bulunamadı!", "warning");

        }
    }

    const handleTemizle = () => {
        setDurum(1)

    }

    //Formik constantları
    const initialValues = {
        //boş kalacak ihtiyaca göre kullanılabilir
    };
    return ((isLoad ? <>
        <div className="d-flex align-self-strech justify-content-center align-items-center"> <CircularProgress /></div>
        {userControlPopup ? (

            <AciklamaAndUserControlPopup
                open={userControlPopup}
                handleClose={closeUserControlPopup}
                isUserControlPopUp={true}
                description={"Bu sayfayı kullanmak için giriş yapmalısınız."}
            />

        ) : null}
    </> : <div className="px-1 px-md-2 px-lg-4 py-3 card   w-100">
        <div className="card-body p-0">
            <Formik
                initialValues={initialValues}
                onSubmit={() => { }}>
                <Form id="kayit-form" className="d-flex w-100 mb-4">
                    <div className="d-flex flex-column flex-sm-row w-100 gap-3 ml-2 mr-2">
                        <div className="d-flex flex-column flex-sm-row gap-2 w-100">
                            <FormControl size="small"
                                sx={{
                                    width: {
                                        xs: "100%",
                                        sm: "50%",
                                        md: "25%",
                                    },
                                    minWidth: 140
                                }}>

                                {/* <InputLabel id="">Yıl</InputLabel> */}
                                <Select
                                    labelId=""
                                    id=""
                                    name=""
                                    //label="yil"
                                    error={durum == undefined && searchControl == false ? true : false}
                                    value={durum}
                                    onChange={(e) => {
                                        setDurum(Number(e.target.value));
                                    }}                               >

                                    <MenuItem selected value={1}>Hepsi</MenuItem>
                                    <MenuItem value={2}>Tebliğ Edilmiş</MenuItem>
                                    <MenuItem value={3}>Tebliğ Edilmemiş</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div className="d-flex  flex-row ms-auto">
                            <SearchComponent
                                fetchData={fetchData}
                                onTemizle={handleTemizle}
                                setData={setData} />
                        </div>
                    </div>
                </Form>
            </Formik>
            {isLoading ?
                <div className="d-flex w-100 justify-content-center align-items-center" style={{ height: '10rem' }}>

                    <CircularProgress />
                </div>
                :
                <TableComponent columns={columns} data={data} recordsPerPage={10}></TableComponent>
            }
            {isPopupVisible && (
                <div style={{ height: "100vh", position: "absolute", width: "100%", padding: "20px", backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: "1000" }}>
                    <IlanReklamVergisiTarifeleriPopup
                        openPopup={openPopup}
                        data={tarifeGetData}
                    />
                </div>
            )}
        </div >
    </div >

    ))
}

export default OdemeEmirleri;